export const selectpriceTokens = (state: any) => state.bestPriceCoins;
